const P=a=>{const t=window.theme.locale.rootUrl==="/"?"":window.theme.locale.rootUrl;return`${window.location.origin}${t}/products/${a.handle}`},M=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),z=(a,t)=>{const i=t.getTemplateOptions("product"),b=i.productPageUrl(a),m=t.getPrice?t.getPrice(a):a.price,$=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,w=t.isProductOnSale($,m),v=a.images,g=v?v.length:0,C=a.featured_image||(v&&v.length>0?v[0]:null);let k="default";g>1&&(k=i.forceHoverGallery?"hover":"gallery");const y=()=>{var n,s,d;let l="";if(w&&(l+='<div class="product-card__badge badge body-extra-small">Sale<span>%</span></div>'),(d=(s=(n=a.metafields)==null?void 0:n.card)==null?void 0:s.badges)!=null&&d.value)for(const c of a.metafields.card.badges.value)l+=`<div class="product-card__badge badge body-extra-small">${c.name}</div>`;return l?`<div class="product-card__badges">${l}</div>`:""},u=()=>{var n,s,d;let l="";if(a.options_with_values){for(const c of a.options_with_values)if(c.name==="Size"){let o="";for(const e of c.values){const r=a.variants.find(f=>f.option1===e||f.option2===e||f.option3===e),p=r?r.available:!1;o+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-option-${M(e)}"
                  name="Size"
                  value="${e}"
                  data-variant-id="${(r==null?void 0:r.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${p?"":"disabled"}
                >
                <label
                  for="${i.context||"card"}-${a.id}-option-${M(e)}"
                  ${p?"":"disabled"}
                  class="quick-add-form__variant-label${p?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${e}</span>
                </label>
              </div>
            `}l+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${i.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${o}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}else if(c.name==="Colour"||c.name==="Color"){let o="";for(let e=0;e<Math.min(c.values.length,3);e++){const r=c.values[e],p=a.variants.find(q=>q.option2===r),f=(s=(n=r.swatch)==null?void 0:n.color)==null?void 0:s.rgba,x=(d=r.swatch)==null?void 0:d.image;o+=`
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-color-${M(r)}"
                  name="Color"
                  value="${r}"
                  data-variant-id="${(p==null?void 0:p.id)||""}"
                  class="quick-add-form__variant-input visually-hidden"
                  ${r.selected?"checked":""}
                >
                <label
                  for="${i.context||"card"}-${a.id}-color-${M(r)}"
                  class="quick-add-form__variant-label--swatch${x?" quick-add-form__variant-label--swatch-image":""}"
                  data-product-url="${r.product_url||""}"
                  data-swatch
                  data-color="${M(r)}"
                  ${f||x?`style="${f?`background-color: rgba(${f}); --swatch-color: rgba(${f});`:""}${x?`background-image: url(${x});`:""}"`:`style="--swatch-color: var(--swatch-color-${M(r)});"`}
                >
                  <span class="visually-hidden">${r}</span>
                </label>
              `}c.values.length>3&&(o+=`
                <div class="quick-add-form__color-swatches-more">
                  <span>+${c.values.length-3}</span>
                </div>
              `),l+=`
              <div class="quick-add-form__color-swatches">
                ${i.showLabel?'<label for="Color" class="quick-add-form__label">Color</label>':""}
                ${o}
              </div>
            `}}return l},_=()=>w?`
        <span class="product-card__price--sale">${t.formatCurrency(m)}</span>
        <s class="product-card__price--compare">${t.formatCurrency($)}</s>
      `:`<span class="product-card__price--regular">${t.formatCurrency(m)}</span>`,h=()=>{if(k==="gallery"&&g>1){let l="";for(let n=0;n<Math.min(g,3);n++){const s=v[n];l+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${s.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${l}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-progress-bar" data-gallery-progress-bar>
            <span></span>
          </div>
        </div>
      `}else if(k==="hover"&&g>1){let l="";for(let n=0;n<Math.min(g,2);n++){const s=v[n];l+=`<img src="${s.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${l}
        </a>
      `}else return`
        <a class="product-card__default-image" href="${b}">
          ${C?`<img src="${C.src}" alt="${a.title}" loading="lazy">`:'<div class="placeholder-image"><p class="site-title">CDP</p></div>'}
        </a>
      `};return`
    <product-card
      data-product-card
      class="product-card"
      data-product-handle="${a.handle}"
      data-template-type="${i.forceHoverGallery&&g>1?"card-hover":"card"}"
    >
      <div class="product-card__media">
        ${y()}
        ${h()}
      </div>
      <div class="product-card__meta-wrapper">
        <div class="product-card__meta">
          <p class="product-card__title">${a.title.split(" - ")[0]}</p>
          <div class="product-card__price">
            ${_()}
          </div>
          <div class="product-card__quick-add-form">
            ${u()}
          </div>
          <button
            class="product-card__quick-add-button"
            type="button"
            data-quick-add-modal-toggle
            data-product-url="${a.url||b}"
          >
            <svg class="icon icon-bag" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 7.5V5.5C8 3.567 9.567 2 11.5 2C13.433 2 15 3.567 15 5.5V7.5M3 7.5H20V20.5C20 21.328 19.328 22 18.5 22H4.5C3.672 22 3 21.328 3 20.5V7.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </product-card>
  `},L=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),H=(a,t)=>{const i=t.getTemplateOptions("product"),b=i.productPageUrl(a),m=t.getPrice?t.getPrice(a):a.price,$=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,w=$>m,v=a.images,g=v?v.length:0,C=window.theme.productCard.maxSlides,k=g<C?g:C;let y="gallery";g<=1&&(y="default"),g===0&&(y="empty"),i.forceHoverGallery&&(y="hover");const u=()=>{let d="";if(a.options_with_values){for(const c of a.options_with_values)if(c.name==="Size"){let o="";for(const e of c.values){const r=(e==null?void 0:e.name)||e,p=a.variants.find(x=>x.option1===r||x.option2===r||x.option3===r),f=p?p.available:!1;o+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-option-${L(r)}"
                  name="Size"
                  value="${r}"
                  data-variant-id="${(p==null?void 0:p.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${f?"":"disabled"}
                >
                <label
                  for="${i.context||"card"}-${a.id}-option-${L(r)}"
                  ${f?"":"disabled"}
                  class="quick-add-form__variant-label${f?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${r}</span>
                </label>
              </div>
            `}d+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${i.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${o}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}}return`
      <div class="quick-add-form__variant-options">
        ${d}
      </div>
    `},_=()=>{const d=a.tags||[],c=d.some(r=>r.includes("badge:"));if(!(w||c))return"";let e="";if(w)e=`
        <div class="product-card__badge badge product-card__badge--sale">
          Save <span>${Math.round(($-m)*100/$)}%</span>
        </div>
      `;else{let r=!1;if(!r){for(const p of d)if(p.includes("badge:use-code-")){e=`<div class="product-card__badge badge product-card__badge--use-code">Use Code ${p.replace("badge:use-code-","").replace(/-/g," ").toUpperCase()}</div>`,r=!0;break}}if(!r&&d.includes("badge:trending")&&(e='<div class="product-card__badge badge product-card__badge--trending">Trending</div>',r=!0),!r&&d.includes("badge:low-in-stock")&&(e='<div class="product-card__badge badge product-card__badge--low-stock">Low in Stock</div>',r=!0),!r){for(const p of d)if(p.includes("badge:custom-")){e=`<div class="product-card__badge badge product-card__badge--custom">${p.replace("badge:custom-","").replace(/-/g," ").toUpperCase()}</div>`,r=!0;break}}!r&&d.includes("badge:coming-soon")&&(e='<div class="product-card__badge badge product-card__badge--coming-soon">Coming Soon</div>',r=!0),!r&&d.includes("badge:sold-out")&&(e='<div class="product-card__badge badge product-card__badge--sold-out">Sold Out</div>',r=!0),!r&&d.includes("badge:pre-order")&&(e='<div class="product-card__badge badge product-card__badge--pre-order">Pre-order</div>',r=!0),!r&&d.includes("badge:most-loved")&&(e='<div class="product-card__badge badge product-card__badge--most-loved">Most Loved</div>',r=!0),!r&&d.includes("badge:best-seller")&&(e='<div class="product-card__badge badge product-card__badge--best-seller">Best Seller</div>',r=!0),!r&&d.includes("badge:new")&&(e='<div class="product-card__badge badge product-card__badge--new">New</div>',r=!0)}return e?`<div class="product-card__badges">${e}</div>`:""},h=()=>$>m?`
        <span class="product-card__price--sale">${t.formatCurrency(m)}</span>
        <s class="product-card__price--compare">${t.formatCurrency($)}</s>
      `:`<span class="product-card__price--regular">${t.formatCurrency(m)}</span>`,l=()=>{if(y==="gallery"&&g>1){let d="";for(let c=0;c<Math.min(g,C);c++){const o=v[c];d+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${o.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${d}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-pagination body-small" data-pagination>
            <span>1</span><span>/</span><span>${k}</span>
          </div>
        </div>
      `}else if(y==="hover"&&g>1){let d="";for(let c=0;c<Math.min(g,2);c++){const o=v[c];d+=`<img src="${o.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${d}
        </a>
      `}else if(y==="default"){const d=a.featured_image;return`
        <a class="product-card__default-image" href="${b}">
          ${d?`<img src="${d.src}" alt="${a.title}" loading="lazy">`:""}
        </a>
      `}else return'<div class="product-card__gallery-item-image placeholder-svg"></div>'},n=()=>{var c,o,e;return`
      <div class="product-card__meta">
        ${(e=(o=(c=a.metafields)==null?void 0:c.card)==null?void 0:o.badges)!=null&&e.value?`
      <div class="product-card__badges--mobile">
        ${_()}
      </div>
    `:""}
        <p class="product-card__title">${a.title.split(" - ")[0]}</p>
        <div class="product-card__price">
          ${h()}
        </div>
        <div class="product-card__form-wrapper">
          <div class="product-card__quick-add-form">
            ${u()}
          </div>
        </div>
      </div>
    `};return`
    <product-card
      data-product-card
      class="product-card"
      data-template-type="card"
      data-product-handle="${a.handle}"
    >
      <div class="product-card__media">
        ${_()}
        ${l()}
        <button
          class="product-card__quick-add-button"
          type="button"
          data-quick-add-modal-toggle
          data-product-url="${a.url||b}"
        >
          <svg class="icon icon-plus" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      ${n()}
    </product-card>
  `},S=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),B=(a,t)=>{const i=t.getTemplateOptions("product"),b=i.productPageUrl(a),m=t.getPrice?t.getPrice(a):a.price,$=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,w=$>m,v=a.images,g=v?v.length:0,C=3;let k="hover";g<=1&&(k="default"),i.forceGallery&&(k="gallery");const y=()=>{let s="";if(a.options_with_values){for(const d of a.options_with_values)if(d.name==="Size"){let c="";for(const o of d.values){const e=(o==null?void 0:o.name)||o,r=a.variants.find(f=>f.option1===e||f.option2===e||f.option3===e),p=r?r.available:!1;c+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-option-${S(e)}"
                  name="Size"
                  value="${e}"
                  data-variant-id="${(r==null?void 0:r.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${p?"":"disabled"}
                >
                <label
                  for="${i.context||"card"}-${a.id}-option-${S(e)}"
                  ${p?"":"disabled"}
                  class="quick-add-form__variant-label${p?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${e}</span>
                  <svg aria-label="Tick icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1198_25368)">
                  <path d="M6.90909 11L6.55874 11.3567C6.75324 11.5478 7.06494 11.5478 7.25945 11.3567L6.90909 11ZM14.5 8C14.5 11.5899 11.5899 14.5 8 14.5V15.5C12.1421 15.5 15.5 12.1421 15.5 8H14.5ZM8 14.5C4.41015 14.5 1.5 11.5899 1.5 8H0.5C0.5 12.1421 3.85786 15.5 8 15.5V14.5ZM1.5 8C1.5 4.41015 4.41015 1.5 8 1.5V0.5C3.85786 0.5 0.5 3.85786 0.5 8H1.5ZM8 1.5C11.5899 1.5 14.5 4.41015 14.5 8H15.5C15.5 3.85786 12.1421 0.5 8 0.5V1.5ZM3.64965 8.49958L6.55874 11.3567L7.25945 10.6433L4.35035 7.78613L3.64965 8.49958ZM7.25945 11.3567L12.3504 6.35672L11.6496 5.64328L6.55874 10.6433L7.25945 11.3567Z" fill="currentColor" />
                  </g>
                  <defs>
                  <clipPath id="clip0_1198_25368">
                  <rect width="16" height="16" fill="white"/>
                  </clipPath>
                  </defs>
                  </svg>
                </label>
              </div>
            `}s+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${i.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${c}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}}return s},u=()=>{const s=a.tags||[],d=s.some(e=>e.includes("badge:"));if(!(w||d))return"";let o="";if(w)o=`
        <div class="product-card__badge badge product-card__badge--sale">
          Save <span>${Math.round(($-m)*100/$)}%</span>
        </div>
      `;else{let e=!1;if(!e){for(const r of s)if(r.includes("badge:use-code-")){o=`<div class="product-card__badge badge product-card__badge--use-code">Use Code ${r.replace("badge:use-code-","").replace(/-/g," ").toUpperCase()}</div>`,e=!0;break}}if(!e&&s.includes("badge:trending")&&(o='<div class="product-card__badge badge product-card__badge--trending">Trending</div>',e=!0),!e&&s.includes("badge:low-in-stock")&&(o='<div class="product-card__badge badge product-card__badge--low-stock">Low in Stock</div>',e=!0),!e){for(const r of s)if(r.includes("badge:custom-")){o=`<div class="product-card__badge badge product-card__badge--custom">${r.replace("badge:custom-","").replace(/-/g," ").toUpperCase()}</div>`,e=!0;break}}!e&&s.includes("badge:coming-soon")&&(o='<div class="product-card__badge badge product-card__badge--coming-soon">Coming Soon</div>',e=!0),!e&&s.includes("badge:sold-out")&&(o='<div class="product-card__badge badge product-card__badge--sold-out">Sold Out</div>',e=!0),!e&&s.includes("badge:pre-order")&&(o='<div class="product-card__badge badge product-card__badge--pre-order">Pre-order</div>',e=!0),!e&&s.includes("badge:most-loved")&&(o='<div class="product-card__badge badge product-card__badge--most-loved">Most Loved</div>',e=!0),!e&&s.includes("badge:best-seller")&&(o='<div class="product-card__badge badge product-card__badge--best-seller">Best Seller</div>',e=!0),!e&&s.includes("badge:new")&&(o='<div class="product-card__badge badge product-card__badge--new">New</div>',e=!0)}return o?`<div class="product-card__badges">${o}</div>`:""},_=()=>`
      <div class="product-card__price-wrapper">
        ${w?`<s class="product-card__price--compare">${t.formatCurrency($)}</s>`:""}
        <span class="product-card__price--${w?"sale":"regular"}">${t.formatCurrency(m)}</span>
      </div>
    `,h=()=>{if(k==="gallery"&&g>1){let s="";for(let d=0;d<Math.min(g,C);d++){const c=v[d];s+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${c.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${s}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-progress-bar" data-gallery-progress-bar>
            <span></span>
          </div>
        </div>
      `}else if(k==="hover"&&g>1){let s="";for(let d=0;d<Math.min(g,2);d++){const c=v[d];s+=`<img src="${c.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${s}
        </a>
      `}else{const s=a.featured_image;return`
        <a class="product-card__default-image" href="${b}">
          ${s?`<img src="${s.src}" alt="${a.title}" loading="lazy" placeholder="product">`:'<div class="product-card__placeholder placeholder-svg"></div>'}
        </a>
      `}},l=()=>`
      <button class="product-card__wishlist-button product-card__cta" type="button">
        <svg class="icon icon-heart" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.5783 8.50903 2.9987 7.05 2.9987C5.59096 2.9987 4.19169 3.5783 3.16 4.61C2.1283 5.6417 1.5487 7.04097 1.5487 8.5C1.5487 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6053C22.3095 9.93789 22.4518 9.22248 22.4518 8.5C22.4518 7.77752 22.3095 7.06211 22.0329 6.39467C21.7563 5.72723 21.351 5.1208 20.84 4.61V4.61Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `,n=()=>{const s=`
      <div class="product-card__badges-mobile">
        ${u()}
      </div>
    `;return`
      <div class="product-card__meta">
        <p class="product-card__title">${a.title.charAt(0).toUpperCase()+a.title.slice(1).toLowerCase().split(" - ")[0]}</p>
        <div class="product-card__price">
          ${_()}
        </div>
        ${s}
      </div>
    `};return`
    <product-card
      data-product-card
      class="product-card"
      data-template-type="card"
      data-product-handle="${a.handle}"
    >
      <div class="product-card__media">
        ${u()}
        ${l()}
        ${h()}
        <div class="product-card__ctas">
          <button
            class="product-card__quick-add-button product-card__cta"
            type="button"
            data-quick-add-modal-toggle
            data-product-url="${a.url||b}"
          >
            <svg class="icon icon-plus" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          ${l()}
        </div>
        <div class="product-card__quick-add-form">
          ${y()}
        </div>
      </div>
      ${n()}
    </product-card>
  `},T=(a,t)=>{var m;const i=((m=window.theme)==null?void 0:m.brandEnvironment)||"cdp";switch(i==="gia"?"iamgia":i){case"iamgia":return H(a,t);case"tigermist":return B(a,t);case"cdp":default:return z(a,t)}},A=(a,t)=>{var v,g,C,k,y;const i=((v=t==null?void 0:t.dataset)==null?void 0:v.sectionId)||"no-results",b=(g=t==null?void 0:t.dataset)==null?void 0:g.title,m=(C=t==null?void 0:t.dataset)==null?void 0:C.headingSize,$=(k=t==null?void 0:t.dataset)==null?void 0:k.buttonLabel,w=(y=t==null?void 0:t.dataset)==null?void 0:y.buttonUrl;return{widget:{options:{limit:a,displayFormat:"grid",includeTagalysCSS:!1},render:(u,_)=>{const h=_.props,n=h.helpers.getProducts();if(h.loading===!1)return n.length===0?null:u`
            <${_.templates.title} />
            <${_.templates.productList} />
            <${_.templates.button} />
          `}},title:{render:u=>b?u`
            <div class="product-recommendations__title">
              <h2 class="title inline-richtext ${m}">${b}</h2>
            </div>
          `:u``},productList:{render:(u,_)=>u`
        <slider-component class="slider-component-full-width">
          <${_.templates.products} />
        </slider-component>
      `},products:{render:(u,_)=>{const l=_.props.helpers.getProducts();return u`<ul
          id="Slider-${i}"
          class="results-grid results-grid--default list-inline m-results-grid--2"
        >
          ${l.map((n,s)=>u`<li class="results-grid__tile">
                <${_.templates.product} key=${s} product=${n} />
              </li>`)}
        </ul> `}},product:{options:{productPageUrl(u){return P(u)}},render:(u,_)=>{const h=_.props,l=h.product,n=h.helpers;return u`<div
          class="tagalys-section__slide"
          id="Slide-${l.id}"
          dangerouslySetInnerHTML=${{__html:T(l,n)}}
        />`}},carouselActions:{render:u=>{var _,h,l,n,s,d;return u`
        <div class="slider-buttons">
          <button
            type="button"
            class="slider-button slider-button--prev"
            name="previous"
            aria-label="${(l=(h=(_=window.theme)==null?void 0:_.strings)==null?void 0:h.accessibility)==null?void 0:l.previousSlide}"
            aria-controls="Slider-${i}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
          <button
            type="button"
            class="slider-button slider-button--next"
            name="next"
            aria-label="${(d=(s=(n=window.theme)==null?void 0:n.strings)==null?void 0:s.accessibility)==null?void 0:d.nextSlide}"
            aria-controls="Slider-${i}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
        </div>
      `}},button:{render:u=>$&&w?u`
            <div class="product-recommendations__button">
              <a href="${w}" class="button button--secondary">${$}</a>
            </div>
          `:u``}}};export{P as c,T as r,A as t};
